import store from '../../store'
import external_manager from "./external_manager.vue";

window.external_manager =  new Vue({
    store,
    el: '#external_manager',
    name : "external_manager",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        external_manager
    }

});
